/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { AuthScreenFrame } from '../../shell/brand/AuthScreenFrame';
import { AppLogoMark } from '../../shell/brand/AppLogoMark';
import { ModalScrollScreen } from '../../shared/layout/ModalScrollScreen';
import { authFormUi } from './components/authFormUi';
import { AuthWhatsAppHelpLink } from './components/AuthWhatsAppHelpLink';

type Props = {
  onBackToLogin: () => void;
};

/**
 * El enlace del mail no dejó una sesión de recovery válida (caducado, precargado por Gmail, etc.).
 */
export function PasswordRecoveryFailedScreen({ onBackToLogin }: Props) {
  return (
    <AuthScreenFrame>
      <ModalScrollScreen
        variant="auth"
        contentContainerStyle={authFormUi.scrollCenter}
        keyboardShouldPersistTaps="handled"
      >
        <View style={authFormUi.card} accessibilityLabel="Enlace de recuperación inválido">
          <View style={authFormUi.brandBlock}>
            <AppLogoMark size={56} showWordmark />
          </View>

          <View style={styles.head}>
            <Text style={authFormUi.title}>Ese enlace ya no sirve</Text>
            <Text style={authFormUi.subtitle}>
              Pedí uno nuevo desde el login («¿Olvidaste tu contraseña?»). Abrilo en el navegador, no
              en la vista previa del correo. Si es urgente, escribinos por WhatsApp.
            </Text>
          </View>

          <TouchableOpacity
            style={authFormUi.primaryBtn}
            onPress={onBackToLogin}
            accessibilityRole="button"
            accessibilityLabel="Volver al login"
            testID="auth.recovery-failed-back"
          >
            <Text style={authFormUi.primaryLabel}>Volver al login</Text>
          </TouchableOpacity>

          <View style={authFormUi.links}>
            <AuthWhatsAppHelpLink testID="auth.recovery-failed-whatsapp" muted={false} />
          </View>
        </View>
      </ModalScrollScreen>
    </AuthScreenFrame>
  );
}

const styles = StyleSheet.create({
  head: {
    gap: 8,
  },
});
